import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@xinosolutions/xs-auth-react';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { SIDEBAR_WIDTH } from '../../utils/layoutUtils';
import AppLoader from '../../components/GeneralComponents/AppLoader';
import { useProductMember } from '../../context/ProductContext';
import './DashboardLayout.css';

/**
 * Dashboard shell — auth gate matches xs-sites-web-app (XS Auth only).
 * Product session (member_session → member_init) loads in ProductProvider.
 */
export default function DashboardLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(SIDEBAR_WIDTH);

  const { isAuthenticated, loading: authLoading } = useAuth();
  const { loading: productLoading } = useProductMember();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handlePermanentDrawer = () => {
    if (drawerWidth) {
      setDrawerWidth(0);
    } else {
      setDrawerWidth(SIDEBAR_WIDTH);
    }
  };

  useEffect(() => {
    if (authLoading) return;
    if (!isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate]);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  if (authLoading || (isAuthenticated && productLoading)) {
    return <AppLoader wrapperClassName="circular-progress" />;
  }

  if (!isAuthenticated) {
    return null;
  }

  const scrollClass = pathname.includes('dashboard') ? 'scroll-visible' : 'scroll-auto';

  return (
    <div className="xs-dashboard-root">
      <AppHeader
        drawerWidth={drawerWidth}
        handleDrawerToggle={handleDrawerToggle}
        handlePermanentDrawer={handlePermanentDrawer}
      />
      <AppSidebar
        drawerWidth={drawerWidth}
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
      />
      <div className={`xs-dashboard-main ${scrollClass}`}>
        <Outlet />
      </div>
    </div>
  );
}
